import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { EventRule } from '@/features/event-rules/schemas/event-rules.schema.ts';

export const useGetUserEventRulesQuery = () => {
  return useQuery({
    queryKey: ['event-rules'],
    queryFn: async () => {
      const { data } = await client.get<{ body: EventRule[] }>(`/events/rules`);

      return data.body;
    },
    refetchInterval: 1000 * 60 * 5,
  });
};
